// extracted by mini-css-extract-plugin
module.exports = {"container":"floatBottomTips_container__h7kGp","text":"floatBottomTips_text__fqa5g","right":"floatBottomTips_right__NacwT"};